module.exports = __webpack_public_path__ + "static/media/4.6dfb8563.JPG";